module.exports = __webpack_public_path__ + "img/pedestalIcon.43f3724b.png";